import Base from 'base/control/checkbox'

export default {
  Base,
}
